import { render, staticRenderFns } from "./MitActionRemovePersonPage.vue?vue&type=template&id=37eeecd0&scoped=true"
import script from "./MitActionRemovePersonPage.vue?vue&type=script&lang=js"
export * from "./MitActionRemovePersonPage.vue?vue&type=script&lang=js"
import style0 from "./MitActionRemovePersonPage.vue?vue&type=style&index=0&id=37eeecd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eeecd0",
  null
  
)

export default component.exports